var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FloatingPanel',[_c('div',{staticClass:"canvas-blocks-custom-footer-BlockPanel"},[_c('div',{attrs:{"slot":"Algemeen"},slot:"Algemeen"},[_c('CommonInputs',{attrs:{"options":_vm.options}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }